import classNames from 'classnames';

import Checkbox from 'components/Checkbox';

import styles from './CheckboxField.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClassName?: string;
}

function CheckboxField({
  label,
  className,
  labelClassName,
  ...restProps
}: Props) {
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={classNames(styles.root, className)}
    >
      <Checkbox {...restProps} />
      {label ? (
        <label className={classNames(styles.label, labelClassName)}>
          {label}
        </label>
      ) : null}
    </div>
  );
}

export default CheckboxField;
